<template>
  <div class="circle-container">
    <svg class="progress-ring" :width="size" :height="size">
      <circle
        class="progress-ring__bg"
        :stroke="bgColor"
        :stroke-width="stroke"
        :r="radius"
        :cx="center"
        :cy="center"
      />
      <circle
        class="progress-ring__value"
        :stroke="color"
        :stroke-width="stroke"
        :r="radius"
        :cx="center"
        :cy="center"
        :stroke-dasharray="circumference"
        :stroke-dashoffset="offset"
      />
    </svg>

    <div class="count">
      <div class="count-numbers">
        <span class="success">{{ successCount }}</span>
        /
        <span class="fail">{{ failedCount }}</span>
      </div>
      <transition name="fade-up">
        <div v-if="isFinished !== '' && showFinished" class="complete">완료</div>
      </transition>
    </div>

    <div class="log-list" v-if="logs.length > 0">
      <div
        v-for="(log, i) in logs.slice(-3)"
        :key="i"
        class="log-item"
        :class="{ success: log.isSuccess, fail: !log.isSuccess }"
      >
        {{ log.message || (log.isSuccess ? '성공' : '실패') }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    value: Number,
    color: { type: String, default: '#4caf50' },
    bgColor: { type: String, default: '#e0e0e0' },
    size: { type: Number, default: 72 },
    stroke: { type: Number, default: 8 },
    successCount: Number,
    failedCount: Number,
    isFinished: String,
    showFinished: Boolean,
    logs: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    radius() { return (this.size - this.stroke) / 2; },
    center() { return this.size / 2; },
    circumference() { return 2 * Math.PI * this.radius; },
    offset() { return this.circumference * (1 - this.value / 100); },
  },
}
</script>

<style scoped lang="scss">
.circle-container {
  position: relative;
  width: fit-content;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.progress-ring {
  transform: rotate(-90deg);
}

.progress-ring__bg,
.progress-ring__value {
  fill: none;
  transition: stroke-dashoffset 0.4s ease;
  stroke-linecap: round;
  transform-origin: center;
}

.progress-ring__bg {
  opacity: 0.3;
}

.count {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 600;
  font-size: 9px;
  line-height: 1.4;

  .count-numbers {
    font-size: 10px;
  }

  .success {
    color: #39a10e;
  }

  .fail {
    color: #f44336;
  }

  .complete {
    margin-top: 4px;
    font-size: 10px;
    color: #3e5cfa;
  }
}

.log-list {
  margin-top: 6px;
  font-size: 10px;
  max-width: 100px; // 로그 없을 때 빈 공백이 생기지 않도록 고정폭 제거
  text-align: center;

  .log-item {
    margin: 2px 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &.success {
      color: #4caf50;
    }

    &.fail {
      color: #f44336;
    }
  }
}
</style>
